import { scales } from '../currencies/utils';
import { MoneyScaled, Money } from '../types';

export const addScaleToMoney = ({
  amount,
  currencyCode,
}: Money): MoneyScaled => {
  const scale = scales[currencyCode];
  return {
    amount: Math.round(amount * Math.pow(10, scale)),
    currencyCode,
    scale: scale,
  };
};
